import { useThree } from '@react-three/fiber'
import { Suspense, useEffect, useRef } from 'react'
import { Group, Object3D, Vector2, Vector3 } from 'three'
import { useSceneStore } from '../../../a.scenes/GameScene/store'
import { disposeTree } from '../../../utils/threejs'
import CharacterConfig from '../../../f.assets/Characters/scripts/classes/CharacterConfig'
import InteractiveTileConfig from '../../Grid/scripts/classes/InteractiveTileConfig'
import createEmptyGrid from '../../Grid/scripts/importHelpers/createEmptyGrid'
import getGridDimensionsFromTiles from '../../Grid/scripts/importHelpers/getGridDimensionsFromTiles'
import { Model as Level1 } from './components/level1'
import { Model as Level2 } from './components/level2'
import { Model as Level3 } from './components/level3'
import { Model as Level4 } from './components/level4'
import { Model as Level5 } from './components/level5'
import { Model as LootsAndPillars } from './components/lootsAndPillars'
import { Model as Surroundings } from './components/surroundings'
import { useScenesStore } from '../../../b.providers/ScenesProvider/store'
import { CHARACTER_TYPES } from '../../../f.assets/Characters/scripts/constants'

const Graveyards = ({ id }: { id: string }) => {
  const initGrid = useSceneStore(s => s.terrain.initGrid)
  // const initCharacters = useSceneStore(s => s.characters.initCharacters)
  const setGridOrigin = useSceneStore(s => s.terrain.setGridOrigin)
  const homeTeam = useScenesStore(s => s.user.team)
  const lootsAndPillarsRotateY = homeTeam === CHARACTER_TYPES.JACK ? 0 : Math.PI

  const { scene } = useThree()
  const ref = useRef<Group | null>(null)
  useEffect(() => {
    // iterates scene and look for interactive tiles
    const interactiveTiles: Object3D[] = []

    ref.current?.traverse(obj => {
      if (obj.userData.isGrid === 1 || obj.name.includes('InteractiveTile')) {
        interactiveTiles.push(obj)
      }
    })

    const { minX, minY, maxX, maxY } = getGridDimensionsFromTiles(
      // x, y in js grid is x, z coords in threejs
      interactiveTiles.map(t => ({
        x: t.position.x,
        y: t.position.z,
      })),
    )

    const interactiveGrid: InteractiveTileConfig[][] = createEmptyGrid({ minX, minY, maxX, maxY })

    const charactersConfig: CharacterConfig[] = []

    // look for valid positions in grid
    interactiveTiles.forEach(t => {
      // normalize positions to start from 0, 0
      const normalPosition = { x: Math.abs(minY) + t.position.z, y: Math.abs(minX) + t.position.x }

      // truncate in case position comming from Blender have decimal's offset
      const x = Math.trunc(normalPosition.x)
      const y = Math.trunc(normalPosition.y)

      // sets coordinates
      interactiveGrid[x][y].coords = new Vector2(y, x)

      // flag position as valid
      interactiveGrid[x][y].isValid = true

      // switch y by z since in Blender depth is y while in Three scene depth is z.
      interactiveGrid[x][y].position = new Vector3(t.position.x, t.position.y, t.position.z)

      if (t.userData.character !== undefined && t.userData.character !== '') {
        // const character = new CharacterConfig(x, y, t.userData.character)
        // charactersConfig.push(character)
      }
    })

    // removes original objects
    interactiveTiles.forEach(obj => {
      disposeTree(obj)
      if (obj.parent) {
        obj.parent.remove(obj)
      } else {
        scene.remove(obj)
      }
    })

    setGridOrigin(new Vector2(minX, minY))

    // sends a grid with InteractiveTileConfig objects in cells
    const transGrid = interactiveGrid[0].map((_, c) => interactiveGrid.map(r => r[c]))
    initGrid(transGrid) // RETURN GRID CONFIG
    // sends an array with CharacterConfig objects
    // console.log(charactersConfig)

    // initCharacters(charactersConfig) // RETURN CHARS CONFIG
  }, [scene])
  const lightColor = 'pink'// id === 'level1' ? '#7FFFD4' : id === 'level2' ? 'yellow' : id === 'level3' ? 'violet' : id === 'level4' ? 'brown' : 'gray'
  return (
    // RETURN WHAT TO SHOW
    <>
      <pointLight args={[lightColor, 5, 17]} position={[0, 10, 0]} castShadow={false} />
      <group ref={ref} dispose={null}>
        {id === 'level1' && <Level1 />}
        {id === 'level2' && <Level2 />}
        {id === 'level3' && <Level3 />}
        {id === 'level4' && <Level4 />}
        {id === 'level5' && <Level5 />}
      </group>
      <LootsAndPillars rotation={[0, lootsAndPillarsRotateY, 0]} position={[0, 0, lootsAndPillarsRotateY === 0? 0 : -1]}/>
      <Surroundings />
    </>
  )
}

export default Graveyards
